import React, { FC } from 'react';
import { Form } from 'semantic-ui-react'
import { roleLabels, roleTypes } from '../../../interfaces/roleType';

const UserRoleDropDown: FC<any> = ({ onChange, user, value }) => {
    const roleOptions = [
        {
            key: roleTypes.USER,
            text: roleLabels[roleTypes.USER],
            value: roleTypes.USER,
        },
        {
            key: roleTypes.TENANT_ADMIN,
            text: roleLabels[roleTypes.TENANT_ADMIN],
            value: roleTypes.TENANT_ADMIN,
        },
    ];

    if (user.role === roleTypes.ADMINISTRATOR) {
        roleOptions.push(        {
            key: roleTypes.ADMINISTRATOR,
            text: roleLabels[roleTypes.ADMINISTRATOR],
            value: roleTypes.ADMINISTRATOR,
        })
    };

    return (
      <Form.Dropdown
        fluid
        label='Benutzerrolle'
        placeholder='State'
        search
        selection
        options={roleOptions}
        value={value}
        onChange={(e: any, { value }: any) => onChange(value)}
        style={{ marginTop: 4 }}
      />
    )
}

export default UserRoleDropDown;
